module.exports = __webpack_public_path__ + "static/logo-text-only-351d3966f97a8774ff1aa6aa01b9be89.svg";